import React from 'react'
import { CSidebar, CSidebarBrand, CSidebarNav, CImage } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import SidebarNav from './SidebarNav'
import logo from '../assets/brand/logo_name.png'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

export default class Sidebar extends React.Component {

	render() {

		return (
			<CSidebar position="fixed" visible={true}>
				<CSidebarBrand className="d-none d-md-flex" to="/">
					<CImage src={logo} height={35} />
				</CSidebarBrand>
				<CSidebarNav>
					<SimpleBar>
						<SidebarNav 
							selected_menu={this.props.selected_menu} 
							onMenuClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)}
							addnlActions={(clickType) => {this.props.addnlActions(clickType)}}/>
					</SimpleBar>
				</CSidebarNav>
			</CSidebar>
		)
	}
}
